import { render, staticRenderFns } from "./PlatformItemContent.vue?vue&type=template&id=407265df&scoped=true&"
import script from "./PlatformItemContent.vue?vue&type=script&lang=js&"
export * from "./PlatformItemContent.vue?vue&type=script&lang=js&"
import style0 from "./PlatformItemContent.vue?vue&type=style&index=0&id=407265df&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407265df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407265df')) {
      api.createRecord('407265df', component.options)
    } else {
      api.reload('407265df', component.options)
    }
    module.hot.accept("./PlatformItemContent.vue?vue&type=template&id=407265df&scoped=true&", function () {
      api.rerender('407265df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/PlatformItemContent.vue"
export default component.exports